(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trade-waste-maintenance"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tw-maintenance-access')) {
  customElements.define('tw-maintenance-access', class extends HTMLElement {
    connectedCallback() {
      this.setupFrame = requestAnimationFrame(() => this.setup());
    }

    setup() {
      if (this.events) return;
      this.dialog = this.querySelector('[data-tw-password-dialog]');
      this.trigger = this.querySelector('[data-tw-password-trigger]');
      this.input = this.querySelector('[data-tw-password-input]');
      if (!this.dialog || !this.trigger || !this.input) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.trigger.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.addEventListener('click', () => this.openDialog(), options);
      this.querySelector('[data-tw-password-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        this.restoreScroll();
        this.trigger.setAttribute('aria-expanded', 'false');
        this.input.value = '';
        if (this.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);

      // Close only when both press and release occur outside the panel.
      this.dialog.addEventListener('pointerdown', (event) => {
        this.backdropPress = event.target === this.dialog && this.isOutside(event);
      }, options);
      this.dialog.addEventListener('click', (event) => {
        if (this.backdropPress && event.target === this.dialog && this.isOutside(event)) {
          this.dialog.close();
        }
        this.backdropPress = false;
      }, options);

      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button, input, a[href], [tabindex="0"]')]
          .filter((element) => !element.disabled && element.getClientRects().length);
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);

      // Shopify renders form.errors after an unsuccessful password submission.
      if (this.querySelector('[data-tw-password-error]')) this.openDialog();
    }

    openDialog() {
      if (!this.dialog.open) {
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        const style = document.documentElement.style;
        this.previousOverflow = {
          value: style.getPropertyValue('overflow'),
          priority: style.getPropertyPriority('overflow')
        };
        style.setProperty('overflow', 'hidden');
      }
      this.input.focus({ preventScroll: true });
    }

    isOutside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right ||
        event.clientY < rect.top || event.clientY > rect.bottom;
    }

    restoreScroll() {
      if (!this.previousOverflow) return;
      const style = document.documentElement.style;
      if (this.previousOverflow.value) {
        style.setProperty('overflow', this.previousOverflow.value, this.previousOverflow.priority);
      } else {
        style.removeProperty('overflow');
      }
      this.previousOverflow = null;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.setupFrame);
      this.restoreScroll();
      if (this.dialog && this.dialog.open) this.dialog.close();
      if (this.events) this.events.abort();
      if (this.trigger) this.trigger.hidden = true;
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
